export const isValidTransportCompany = (transportCompany = null) => {
  if (transportCompany?.id && transportCompany?.name) {
    return true;
  }

  return false;
};

export class ValidateModelStrategy {
  constructor(model = null) {
    this.model = model;
  }

  _checkNameText({ text = '' }) {
    if (!this.model?.name) return false;

    const value = this.model.name.toLowerCase().match(text);
    return value;
  }

  isRoofSystem() {
    const value = Boolean(this._checkNameText({ text: 'roof system' }));
    return value;
  }

  isCornice() {
    const value = Boolean(this._checkNameText({ text: /карниз/i }));
    return value;
  }

  isCassette() {
    const value = Boolean(this._checkNameText({ text: /кассета/i }));
    return value;
  }

  isVisiblePopupOptionWarningBtnClose() {
    const modelId = this.model?.id;
    if (!modelId) return false;

    if ([1, 2].includes(modelId)) {
      return false;
    }

    if ([6, 7].includes(modelId) && this.isCassette()) {
      return false;
    }
    return true;
  }
}

export class ValidateTenderStrategy {
  constructor(props) {
    this.list = props?.list || [];
  }

  _isValidMaxCount(count) {
    return typeof count === 'number' && count > 0;
  }

  _isItemNoValid(item) {
    if (!item) return false;
    const itemName = item?.parameters?.item?.name?.toLowerCase() || '';
    const categoryName = item?.parameters?.category?.name?.toLowerCase() || '';

    return (
      itemName?.match(/услуга/i) ||
      itemName?.match(/услуги/i) ||
      itemName?.match(/гильза/i) ||
      categoryName?.match(/упаковка/i) ||
      categoryName?.match(/упаковки/i)
    );
  }

  _listCountQuantity(exceptionItemIdx = null) {
    return this.list.reduce((acc, value, idx) => {
      if (this._isItemNoValid(value) || exceptionItemIdx === idx) {
        return acc;
      }

      return acc + value.quantity;
    }, 0);
  }

  _getItemByIndex(idx) {
    return this.list?.[idx] || null;
  }

  isError({ maxCount = 0, changeItemIdx = null, newCountItem = 0, changeItem = null }) {
    const itemByIndex = this._getItemByIndex(changeItemIdx);
    if (this._isItemNoValid(changeItem || itemByIndex)) {
      return false;
    }

    if (this._isValidMaxCount(maxCount)) {
      const value = this._listCountQuantity(changeItemIdx) + newCountItem;

      return value > maxCount;
    }

    return false;
  }

  getCurrentQuantity({ changeItemIdx = null, maxCount = 0, newCountItem = 0 }) {
    if (this._isValidMaxCount(maxCount)) {
      const listCountQuantity = this._listCountQuantity(changeItemIdx);
      const value = listCountQuantity + newCountItem;

      if (listCountQuantity >= maxCount) {
        return 0;
      }

      if (value > maxCount) {
        const newValue = maxCount - listCountQuantity;

        return newValue > 0 ? newValue : 0;
      }

      return value;
    }

    return newCountItem;
  }

  getZgiText() {
    return 'Максимальное количество изделий в заказе';
  }

  getZgiErrorText(count) {
    return `${this.getZgiText()} - ${count}`;
  }

  getCutText() {
    return 'Максимальное количество отрезов в заказе';
  }

  getCutErrorText(count) {
    return `${this.getCutText()} - ${count}`;
  }
}
